import React, { useState } from "react"
import withStyles from "react-jss"
import smoothscroll from "smoothscroll-polyfill"
import "./index.css"
import fonts from "./assets/fonts"
import globalStyles from "./data/globalStyles"
import {
  CaseCard,
  CaseCardToggle,
  TickerExperiment,
  TextSection,
  DistributionChart,
  Header,
  Footer,
  StickySectionDivider,
  IntroStickySectionDivider,
} from "./components"
import saraCaseCard from "./data/sara-case-card.json"
import yusefCaseCard from "./data/yusef-case-card.json"
import saraTransformCaseCard from "./data/sara-transform-case-card.json"
import yusefTransformCaseCard from "./data/yusef-transform-case-card.json"
import saraYusefCaseCardScore from "./data/sara-yusef-case-card-score.json"
import {
  textData,
  afterCaseCardSara,
  afterCaseCardYusef,
  afterCaseCardSwitchSara,
  beforeDecisionTree,
  beforeDistributionChart,
  afterDistributionChart,
  decisionTreeText,
} from "./data/text/textData"
import { SECTION_MAX_WIDTH } from "./data/globalStyles"

smoothscroll.polyfill()

const styles = {
  ...fonts,
  ...globalStyles,
  app: {
    width: "100%",
    // maxWidth: SECTION_MAX_WIDTH,
    margin: "0 auto",
  },
  svg: {
    position: "absolute",
    top: 0,
    left: 0,
    pointerEvents: "none",
    zIndex: 100,
  },
  imgBox: {
    display: "grid",
    height: "100%",
  },
  image: {
    maxWidth: "90%",
    maxHeight: "100vh",
    margin: "30px auto",
  },
}

const App = ({ classes }) => {
  const [hideTicker, setHideTicker] = useState(false)
  return (
    <div className="appBox">
      <div className={classes.app}>
        <Header />
        <TickerExperiment hideTicker={hideTicker} />
        <IntroStickySectionDivider
          title="Feeding the Machine"
          setHideTicker={setHideTicker}
        />
        <CaseCard arcData={saraCaseCard} mainId={"saraCaseCard"} />
        <TextSection data={afterCaseCardSara} />
        <CaseCard arcData={yusefCaseCard} mainId={"yusefCaseCard"} />
        <TextSection data={afterCaseCardYusef} />
        <CaseCard
          arcData={saraTransformCaseCard}
          mainId={"saraTransformCaseCard"}
        />
        <TextSection data={afterCaseCardSwitchSara} />
        <CaseCard
          arcData={yusefTransformCaseCard}
          mainId={"yusefTransformCaseCard"}
        />
        <StickySectionDivider
          title="Fork in the Road"
          textSectionData={beforeDecisionTree}
        />
        <TextSection data={decisionTreeText} />
        <br />
        <CaseCardToggle
          arcData={saraYusefCaseCardScore}
          mainId={"saraYusefCaseCardScore"}
        />
        <StickySectionDivider
          title="Crossing the Line"
          textSectionData={beforeDistributionChart}
        />
        <DistributionChart />
        <StickySectionDivider
          title="Sunshine in a Black Box"
          textSectionData={afterDistributionChart}
        />
        <TextSection data={textData} />
        <Footer />
      </div>
    </div>
  )
}

export default withStyles(styles)(App)
